/**
 * Curated "Views" slides for the site-plan card — rendered view maps shown as
 * a slider after the 2D / 3D / 3DS modes. Keyed by `Project.Id`; slides play
 * in array order. Projects without an entry get no Views tab.
 */
const FIREBASE_BASE = 'https://firebasestorage.googleapis.com/v0/b/transformation-office.firebasestorage.app/o/';

const firebaseUrl = (path: string, token: string) =>
  `${FIREBASE_BASE}${encodeURIComponent(path)}?alt=media&token=${token}`;

export interface SitePlanViewSlide {
  url: string;
  label: string;
}

const SITE_PLAN_VIEWS: Record<string, readonly SitePlanViewSlide[]> = {
  // Thomson Reserve
  P2511010: [
    ['Thomson_Reserve_View_1_Map.png', '57413790-f48c-4385-a704-a1bda4a3deaa'],
    ['Thomson_Reserve_View_2_Map.png', '860fe5b0-ad4a-4fcf-a7f6-fc2aa2af11c8'],
    ['Thomson_Reserve_View_3_Map.png', '4cf5034d-6bd5-4884-aaef-2039cedbe8d4'],
    ['Thomson_Reserve_View_4_Map.png', '7387f08a-0606-4700-82b5-bc8ddeecf8db'],
    ['Thomson_Reserve_View_5_Map.png', '724cc33f-b2ea-4d3a-8c06-bc811e6af2f5'],
    ['Thomson_Reserve_View_6_Map (2).png', '1f2bb5e1-208f-4546-aaae-d2f7ee074d89'],
    ['Thomson_Reserve_View_7_Map.png', '8678f2cb-225d-4492-b0a2-8c57a253494d'],
    ['Thomson_Reserve_View_8_Map.png', '45ae06e0-e28e-41bd-b490-ccd3849356d2'],
  ].map(([file, token], i) => ({
    url: firebaseUrl(`thomson-reserve-views/${file}`, token),
    label: `View ${i + 1}`,
  })),
};

/** Slides for `projectId`, or an empty list when the project has none. */
export function getSitePlanViews(projectId?: string | number | null): readonly SitePlanViewSlide[] {
  if (projectId === null || projectId === undefined) return [];
  return SITE_PLAN_VIEWS[String(projectId).trim().toUpperCase()] ?? [];
}
